export default class ErrorMessages {
    static readonly ContentHubClient = Object.freeze({
        IncompatibleVersionsPre3_0:
            "The JavaScript SDK version and server version are incompatible. The Web SDK is only supported in M 3.0 and later.",
        IncompatibleMinimumVersion:
            "The JavaScript SDK version ({0}) and server version ({1}) are incompatible. Server requires SDK version of minimum '{2}'.",
        IncompatibleVersion:
            "The JavaScript SDK version ({0}) and server version ({1}) are incompatible because the SDK is newer than the server. " +
            "Please use an older version of the SDK.",
        NotSupportedFeature:
            "This feature is not supported in Content Hub version '{0}'. It was introduced in version '{1}'.",
    });

    static readonly QueryingClient = Object.freeze({
        MultipleResultsWhenOneExpected: "Server returned multiple entities, when only one was expected.",
        MultipleResults: "Query returned multiple results.",
    });

    static readonly EntitiesClient = Object.freeze({
        UnableToExtractEntityIdFromHeader: "Unable to extract entity id from location header.",
        UnableToExtractLocationHeaderFromResponse: "Unable to extract location header from response.",
    });

    static readonly PoliciesClient = Object.freeze({
        RelatedIdCannotBeNull: "The id of the entity this policy relates to cannot be null.",
    });

    static readonly CultureLoader = Object.freeze({
        CouldNotFindCultures: "Could not find any cultures.",
    });

    static readonly NoPermissionsOnNewEntity = "Cannot load permissions on an entity that has not been persisted yet.";
    static readonly UnknownMemberCondition = "MemberCondition '{0}' is not supported.";
    static readonly UnsupportedMemberDefinition = "MemberDefinition with name '{0}' and type '{1}' is not supported.";

    static readonly NoRoleSpecifiedForSelfRelation =
        "Relation with name '{0}' is self-relation, but had no role specified";

    // Entity
    static readonly Entity = Object.freeze({
        CannotLazyLoad: "Cannot do any lazy loading on an entity that has not been persisted yet.",
        CultureRequired: "Culture is required for culture sensitive properties.",
        CultureNotSupported: "Culture insensitive properties do not support cultures.",
        SelfReferencingRelation:
            "Relation '{0}' is self referencing and multiple relation instances match. Specify the relation role.",
        RelationNameMustMatch: "Relation names do not match.",
        NoPermissionsOnNewEntity: "Cannot load permissions on an entity that has not been persisted yet.",
        PropertyNotFound:
            "Property with name '{0}' does not exist or is not loaded on entity with id '{1}' and definition '{2}'.",
        PropertyDoesNotExist: "Property with name '{0}' does not exist on definition '{1}'.",
        RelationNotFound:
            "Relation with name '{0}' does not exist or is not loaded on entity with id '{1}' and definition '{2}'.",
        RelationDoesNotExist: "Relation with name '{0}' does not exist on definition '{1}'.",
        MultipleRelationsFound: "Found multiple relations with the same name and role.",
        SetIdentifierOnExistingEntity: "Cannot set identifier on an existing entity.",
    });

    static readonly EntityFactory = Object.freeze({
        DefinitionDoesNotExist: "Definition with name '{0}' does not exist.",
    });

    static readonly PropertyFactory = Object.freeze({
        MustBeCultureSensitive: "Property with name '{0}' must be culture sensitive.",
        CannotBeCultureSensitive: "Property with name '{0}' can't be culture sensitive.",
    });

    // Relation mapper
    static readonly UnsupportedRelation = "A relation with cardinality '{0}' and role '{1}' is not supported.";

    // Option list
    static readonly UnknownOptionListType = "Option list type with name '{0}' is not supported.";

    static readonly FinalLifeCycleStatusMapper = Object.freeze({
        UnknownStatus: "LifeCycleStatus '{0}' is not supported.",
    });

    static readonly RelationRoleMapper = Object.freeze({
        UnknownRole: "Role '{0}' is not supported.",
    });
}

export { ErrorMessages };
